const modifyProductionData = (productionData, detectedInputs) => {
  // Constants for production adjustment
  const SHADOW_REDUCTION_FACTOR = 0.25; // 50% reduction for shadowed hours

  // Iterate through each detected input (hours, months, seasons)
  detectedInputs.forEach((input) => {
    const { hours, months } = input;

    // Iterate through the production data for each day
    productionData.forEach((hourlyData, index) => {
      // Calculate the day and hour
      const day = Math.floor(index / 12); // 0-based day index
      const hour = (index % 12) + 7; // 0-based hour index

      // Calculate the month (1-based) from the day
      const month = Math.floor(day / 30.4) + 1; // Approximation: 30.4 days per month

      // Apply modification if the hour and month match the input criteria
      if (months.includes(month) && hours.includes(hour)) {
        productionData[index] *= SHADOW_REDUCTION_FACTOR;
      }
    });
  });

  return productionData;
};

module.exports = { modifyProductionData };
